import React from 'react';

export const AnimationIcon = ({
  width = '24',
  height = '24',
  fill = '#0F2664',
}) => {
  return (
    <div className="feature">
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="6.89356"
          cy="6.90717"
          r="4.5"
          transform="rotate(-11.4574 6.89356 6.90717)"
          stroke={fill}
        />
        <path
          d="M7.29747 11.4168L14.0246 19.6604C14.0584 19.7018 14.1186 19.7093 14.1616 19.6776L15.347 18.8012C15.3867 18.7719 15.399 18.718 15.3761 18.6743L10.4298 9.25142"
          stroke={fill}
        />
        <path
          d="M10.1899 12.348L11.8312 14.8592"
          stroke={fill}
          strokeWidth="0.5"
          strokeLinecap="round"
        />
        <path
          d="M14.7998 18.9999C16 21 18.7007 23 18.7007 19.8814C18.7007 17.8025 18.4999 16.8246 22.8102 16.8246"
          stroke={fill}
        />
      </svg>
    </div>
  );
};
